import { useState } from 'react'

const useFlashMessage = (initialState) => {
  const [message, setMessage] = useState(initialState)

  const showMessage = (newMessage) => {
    setMessage(newMessage)

    window.setTimeout(() => {
      setMessage(null)
    }, 3000)
  }

  const clearMessage = () => {
    setMessage(null)
  }

  return { message, showMessage, clearMessage }
}
export default useFlashMessage
